module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "cancle",
    on: {
      "click": _vm.cancleFn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/close.png"),
      "alt": "取消"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "row row1 clear"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "phone"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNo),
      expression: "phoneNo"
    }],
    attrs: {
      "placeholder": "手机号",
      "type": "tel",
      "maxlength": _vm.phoneLength
    },
    domProps: {
      "value": (_vm.phoneNo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNo = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(1)
      }]
    }
  })])])]), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "row row3 clear"
  }, [_c('div', {
    staticClass: "top clear"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "imgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    attrs: {
      "placeholder": "图形验证码",
      "maxlength": 4
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(2)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "img",
    on: {
      "click": _vm.getImgCodeFn
    }
  }, [_c('xk-img-code', {
    attrs: {
      "code": _vm.imgCodeUrl
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "row row2 clear"
  }, [_c('div', {
    staticClass: "sms"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "numCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smsCode),
      expression: "smsCode"
    }],
    attrs: {
      "placeholder": "短信验证码",
      "type": "tel",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.smsCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.smsCode = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(3)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "numCodeBut",
    class: _vm.phoneCodeText === '获取短信验证码' ? 'numCodeButShow' : '',
    on: {
      "click": _vm.getSmsCodeFn
    }
  }, [_vm._v("\n          " + _vm._s(_vm.phoneCodeText) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', {
    staticClass: "row row5 clear"
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "重置密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(4)
      }]
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('div', {
    staticClass: "row row5 clear"
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "设置6-10位密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(5)
      }]
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "row row5 clear",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "登录密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(4)
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "textBtn",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "forget",
    on: {
      "click": _vm.forgetFn
    }
  }, [_vm._v("\n          忘记密码\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "nextStep",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n          下一步\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "row row5 clear",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "icon-input"
  }, [_vm._m(6), _vm._v(" "), _c('span', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "登录密码",
      "type": "password",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        return _vm.loginStateFn(6)
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "textBtn",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "forget",
    on: {
      "click": _vm.forgetFn
    }
  }, [_vm._v("\n          忘记密码\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loginBut",
    class: _vm.loginState && _vm.agree ? 'loginButShow' : '',
    on: {
      "click": _vm.loginButFn
    }
  }, [_vm._v("\n      " + _vm._s(_vm.forgetState ? '确认' : '登录') + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row row4"
  }, [(_vm.agree) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/login/checked.png"),
      "alt": "已同意"
    },
    on: {
      "click": _vm.changeToUnAgreeFn
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.agree) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/login/uncheck.png"),
      "alt": "未同意"
    },
    on: {
      "click": _vm.changeToAgreenFn
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("已阅读并已同意"), _c('span', {
    staticClass: "protocol",
    on: {
      "click": _vm.userxieyiFn
    }
  }, [_vm._v("《用户协议》")])])])]), _vm._v(" "), (_vm.alertText) ? _c('xk-alert-box', {
    attrs: {
      "text": _vm.alertText
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', [_c('slideVerify', {
    ref: "slideVerify",
    attrs: {
      "loading": _vm.loading,
      "phone": _vm.phoneNo,
      "visible": _vm.visible
    },
    on: {
      "dragEnd": _vm.getSmsCodeFn,
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/phone.png"),
      "alt": "电话号码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/piccode.png"),
      "alt": "图形验证码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/sms.png"),
      "alt": "短信验证码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/password.png"),
      "alt": "重置密码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/password.png"),
      "alt": "重置密码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/password.png"),
      "alt": "重置密码"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/login/password.png"),
      "alt": "重置密码"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f62cccb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 507
// module chunks = 0